import { render, staticRenderFns } from "./LaborView.vue?vue&type=template&id=6fa90d04&scoped=true"
import script from "./LaborView.vue?vue&type=script&lang=js"
export * from "./LaborView.vue?vue&type=script&lang=js"
import style0 from "./LaborView.vue?vue&type=style&index=0&id=6fa90d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa90d04",
  null
  
)

export default component.exports